export default {
  common: {
    month: "month",
    loginButton: "Login",
    submit: "Submit",
    signUp: "Sign up",
    logIn: "Log In",
    logOut: "Log Out",
    cancel: "Cancel",
    confirm: "Confirm",
    close: "Close",
    continue: "Continue",
    back: "Back",
    generalAdmission: "General Admission",
    section: "Section",
    row: "Row",
    seat: {
      one: "Seat",
      other: "Seats",
      zero: "Seats",
    },
    alreadyAMember: "Already a member?",
    clickHere: "Click here",
    loading: "Loading...",
    groupReservationCannotBeChanged:
      "All group reservations are final, and cannot be changed.",
    total: "Total",
    bank: "Bank",
    accountCredit: "Account Credit",
    amountToBeChargedToCC: "Amount to be Charged to CC",
    reserve: "RESERVE",
    purchaseAndReserve: "Purchase & Reserve",
    purchaseAndRedeem: "Purchase & Redeem",
    purchaseAndBook: "Purchase & Book",
    book: "Book",
    redeem: "Redeem",
    accountOwner: "Account Owner",
    memberId: "Member ID: %{memberId}",
    reservationConfirmedMessage:
      "Congratulations! Your reservation was confirmed!",
    reservationWindowDay: "%{days}-day",
    reservationWindowHour: "%{hours}-hour",
    totalQuantity: "Total quantity: %{quantity}",
    copiedButton: "Copied to Clipboard",
    shareButton: "Share",
    shareNotSupportedWarning:
      "Share function is not supported in this browser, please copy the URL above and send it to your friends!",
    point: {
      zero: "Points",
      one: "Point",
      other: "Points",
    },
    hour: {
      zero: "%{count} hour",
      one: "%{count} hour",
      other: "%{count} hours",
    },
    minute: {
      zero: "%{count} minute",
      one: "%{count} minute",
      other: "%{count} minutes",
    },
    createAccountBtnText: "CREATE ACCOUNT",
  },
  labels: {
    home: "Home",
    myGames: "My Events",
    schedule: "Schedule",
    account: "Account",
    email: "Email",
    password: "Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    firstName: "First Name",
    lastName: "Last Name",
    phone: "Phone",
    address: "Address",
    addressLine2: "Address Line 2",
    city: "City",
    state: "State",
    postalCode: "Postal Code",
    // tenant user fields
    birthdate: "Birthdate",
    school: "High School/College/University",
    "grad year": "Graduation Year",
    college: "College/University",
    "zip code": "Zip Code",
  },
  components: {
    BuyFlowPaymentDetailCard: {
      amountDueToday: "Amount due today",
      tooltip:
        "The first month's subscription fee is due at time of purchase. If joining after the season starts, you will pay a prorated amount for the number of events remaining in the current billing month at the time of purchase.",
      okButton: "Confirm",
      then: "then",
      duration: "For %{months} months, starting %{startMonth}",
      payInFull: "Pay in full",
    },
    EventBanner: {
      nextUpcomingEvent: "Next Upcoming Event",
      seatsOnHold: "%{amount} %{seats} on hold",
    },
    NewMemberForm: {
      checkboxText:
        "By clicking Create Account, you acknowledge that you have read and agree to our",
      FanRallyMarketPlaceTOS: "FanRally Marketplace Terms of Service",
    },
    ShareDialog: {
      getCode: "Get Code",
      message:
        "%{userName} has sent you a seat for the %{opponent} vs %{tenant} game on %{eventDate}.\nTo claim the seat, click the link below.\n%{link}",
      info: "This will create a share code that will allow your guests to claim their seats.",
      max: "%{label} Max: %{quantity}",
      guestInvitationCode: "Your Guest Invitation Code:",
      clickShare: "Click Share to share this code with your guests",
      guestPasses: "Guest passes",
      seats: "Seats",
      axsShareMessage:
        "%{type} may be transferred from within the %{appName} app in the following AXS account: %{axsAccountName}.",
      bookingIsFinal: "NOTE: Once transferred, this booking is final.",
    },
    StripePaymentForm: {
      nameOnCard: "Name on card",
      cardNumber: "Card Number",
      expiration: "Expiration Date",
      cvc: "CVC",
      postalCode: "Postal Code",
    },
    PaymentMethodCard: {
      paymentMethod: "Payment Methodology",
      currentCard: "Current Card",
      newCreditCard: "New Credit Card",
      expiresOn: "Expires on",
      updatePaymentMethod: "Update Payment Method",
      paymentMethodUpdatedMessage: "Payment method updated.",
    },
  },
  screens: {
    Account: {
      accountDetails: "Account details",
      yourActivity: "Your activity",
      memberCard: "Member card",
      yourPlans: "Your plans",
      managePlansAndServices: "Manage plans and services",
      addNewMember: "Add new member",
      billing: "Billing",
      updatePaymentMethod: "Update payment method",
      generalSettings: "General settings",
      updateSettings: "Update settings",
      supportResources: "Support resources",
      phone: "Phone",
      email: "Email",
      signOut: "Sign Out",
      upgradeToFullAccount: "Upgrade To Full Account",
      switchMembership: "Switch Membership",
    },
    AccountDetails: {
      personalInformation: "Personal Information",
      additionalMembersInformation: "Additional Members Information",
    },
    AccountSetup: {
      purchaseYourMembership: "Purchase your membership",
      signUp: "SIGN UP",
      logOutHere: "Log Out Here",
    },
    Activity: {
      activityHistory: "Activity History",
      noData: "No data",
      reserveAnEvent: "Reserve an Event",
    },
    Barcode: {
      eventDate: "EVENT DATE",
      generalAdmission: "General Admission",
      section: "Section",
      row: "Row",
      seat: "Seat",
      reservationsNonTransferable: "Reservations are non-transferable",
      animationRequired: "Animation required for entry",
      screenshotNotAccepted: "Screenshots will not be accepted",
      done: "Done",
      barcodeNumber: "Barcode Number",
      seatInfo: "Seat Info",
      importantNotices: "Important Notices",
      contactUs: "Contact Us",
    },
    Dashboard: {
      hello: "Hello",
      myWallet: "My Wallet",
      hide: "Hide",
      seeAllMembers: "See All Members",
      reservationLimit: "Hold up to %{slots} events at a time",
      bookSeatsButton: "Book",
      myNextGame: "My Next Game",
      nextHomeGames: "Next Events",
      viewMore: "View More",
      bankBalance: "Balance",
      unusedVoucher: {
        zero: "Unused Seat Credits",
        one: "Unused Credit",
        other: "Unused Seat Credits",
      },
      seatMembership: "%{perEventMax} seat membership",
      seat: {
        one: "seat",
        other: "seats",
      },
      addSeatCredits: "Add Seat Credits",
      redemptionUsageMonth: "%{redeemed}/%{limit} events used this month",
      redemptionUsageSeason: "%{redeemed}/%{limit} events used this season",
    },
    EditProfile: {
      userInfoUpdatedMessage: "User info updated.",
      title: "Edit Profile",
      changeProfilePhoto: "Change Profile Photo",
      saveButton: "Save",
    },
    EventDetail: {
      cannotReleaseWarning:
        "These reservations cannot be released because the barcodes have already been issued",
      reservationReleasedMessgae: "Reservation released",
      title: "Event Detail",
      manageSeats: "Manage Seats",
      transferSeatsTitle: "Transfer Seats",
      releaseButton: "Release",
      howManySeats: "How many seats would you like to transfer?",
      eventActions: "Event Actions",
      sitWithFriends: "Sit with friends",
      cancelBooking: "Cancel booking",
      showBarcodes: "SHOW BARCODES",
      barcodeMinutesBefore:
        "Barcodes will be available %{barcodeMinutesBefore} before the game.",
      reservationsNonTransferable: "Reservations are non-transferable",
      groupShareMessage:
        "%{userName} has reserved seats for the %{opponentAlias} vs %{tenantAlias} game on %{eventDate}.\nTo reserve seats with %{userFirstName} using your membership, click the link below. \n%{link}",
      groupShareTitle: "Group Event Invitation",
      groupReservationCutOff:
        "Once other party members have joined this group, all reservations within this group will be final, and cannot be changed.",
      guestPassesTitle: "Guest Passes",
      manageGuests: "Manage Guests",
      refund: "Refund",
      calculatingRefund: "Calculating Refund...",
      bankRefund: "Bank Refund: %{amount}",
      accountCreditRefund: "Account Credit Refund: %{amount}",
      amountToBeRefunded: "Amount to be Refunded to CC: %{amount}",
      releaseReservation: {
        one: "Release Reservation",
        other: "Release all reservations",
      },
      releaseReservationPrompt: {
        one: "Are you sure you want to release this reservation?",
        other:
          "Are you sure you want to release all of your reservations for this event?",
      },
      amountPaid: "Amount Paid: %{amount}",
      voucherTransferInitiated: "Voucher Transfer Initiated",
      attendees: "Attendees",
      guestPending: "Guest Pending",
    },
    FinishSignup: {
      title: "Finish Signup",
      heading:
        "In order to complete your account setup, please create a password.",
    },
    ForgotPassword: {
      title: "Reset Password",
      resetButton: "Send Password Reset Code",
      emailSentMessage:
        "An email has been sent to %{email} with a link to reset your password.",
    },
    GroupReservation: {
      title: "Group Reservation",
      youHaveBeenInvited:
        "You have been invited to the following event: %{eventName}",
      localDate: "Local Date: %{date}",
      joinTheCrowd: "Join the crowd!",
      enterYourEmail: "Enter your email address to continue",
      consent:
        "By clicking Continue, you acknowledge that you have read and agree to our Privacy Policy.",
      guestPending: "Guest Pending",
      selectPlan: "Select plan:",
      noValidPlan:
        "You do not have a valid plan package to use for this event.",
      whoIsGoing: "Who is going:",
      optionDisabled:
        "This option is disabled because the members on your account either already have reservations to this event, or they are out of reservation slots. If you wish to attend with this group, you will first need to release enough reservations to free up the required reservation slots.",
      howManySeats: "How many seats? (Maximum: %{max})",
      notEnoughVouchers:
        "You do not have enough vouchers to redeem for this event",
      addGuest: "Add Guest",
      guest: {
        one: "Guest",
        other: "Guests",
      },
      remove: "Remove",
    },
    Guests: {
      inviteGuests: "Invite Guests",
      cardTitle: "Manage Guest Passes",
      howManySeats: "How many seats would you like to share?",
    },
    Login: {
      title: "Login",
      forgotPassword: "Forgot Password?",
    },
    ManageSubscriptions: {
      newMembers: "New Members",
      addNewMember: "Add new member",
      managePlans: "Manage Plans",
    },
    MemberCard: {
      memberCard: "Member Card",
      memberSince: "Member since: %{date}",
    },
    MyEvents: {
      noGamesYet: "You have no reserved events yet. Get Busy!",
      myReservations: "My Reservations: %{size}",
      groupSize: "Group Size: %{size}",
    },
    PaymentMethod: {
      billingPeriod: "Billing period: %{billingPeriod}",
      charges: "Charges: %{charges}",
      paymentMethod: "Payment Method",
      paymentInterval: "Payment Interval",
      changePaymentInterval: "Change payment interval",
      transactionHistory: "Transaction History",
      viewDetails: "View Details",
    },
    Register: {
      stepOneTitle: "Your Plan",
      stepTwoTitle: "Primary Member",
      stepThreeTitle: "Payment Information",
      viewMorePlans: "View More Plans",
      primaryMember: "Primary Member",
      addMemberPhoto: "Add Member Photo (Required for entry)",
      agreeAndContinue: "Agree & Continue",
      agreeAndSignup: "Agree & Sign up",
      emailingBeingUsedError: "Email is being used by a secondary user",
      emailUsedByOtherMemberError:
        "%{email} is already being used by another member.",
      editButton: "Edit",
      additionalMembers: "Additional Members",
      addMember: "Add Member",
      comingSoon: "Coming Soon!",
      addChild: "Add Child",
      child: "Child",
      removeButton: "remove",
      purchaseAdditionalMemberships:
        "You can purchase additional memberships for your friends & family and conveniently manage everything in the same place",
      paymentInterval: "Payment Interval",
      yourPlan: "Your Plan",
      creditCardInformation: "Credit Card Information",
      creatingAccountMessage:
        "Creating your account, this process can take up to a few minutes...",
    },
    Reserve: {
      outstandingBalance: "Outstanding Balance",
      seatsAlreadyTaken:
        "NOTICE: The seats you selected were already taken. Here are the next best available. If you do not wish to reserve these seats, please navigate back to select a different seat.",
      paymentDetails: "Payment Details",
      poweredByFanRally: "Powered by FanRally",
      total: "Total",
      fundsOnAccount: "Funds on Account",
      accountCredit: "Account Credit",
      amountCharged: "Amount to be charged",
      barcodesDeliveredWindow:
        "Barcodes delivered %{hours} before the game. Must have mobile device to enter event.",
      importantMessages: "Important Message",
      seatNumber: "Seat %{number}",
      passApplied: "Pass Applied",
      seatCreditApplied: "Token Applied",
      selectGuestType: "Select Guest Type",
      mustHaveOneAccountMemberAttending:
        "Must have one account member attending.",
    },
    ResetPassword: {
      title: "Reset Password",
      resetButton: "Reset Password",
      passwordResetMessage: "Your password has been reset",
    },
    Schedule: {
      noEligibleEventsBanner:
        "There are currently no eligible events scheduled at this time.",
      noEligibleSubscriptions: "No eligible subscription can be used.",
      noEligibleEvents: "No Eligible Events",

      primaryMemberMustLinkMLB:
        "The primary account holder must first install the MLB Ballpark app on their mobile device, and provide their MLB Ballpark email address before you are able to begin making seat reservations. Please have them log into their account and complete this setup process",
      eventsAvailableSoon: "Events Available Soon",
      outSideReservationWindow:
        "The following events are outside your %{window} reservation window.",
    },
    SeatSelection: {
      preferredSeatNotAvailable:
        "Your preferred seat selection is not available for this %{sectionOrGame}. Please choose another game to check availability for your desired seating. For help or more information, please ",
      section: "Section",
      game: "game",
      call: "call %{phone}",
      email: "email %{email}",
      callOrEmail: "call %{phone} or email %{email}",
      maximumTicketMsg:
        "You already have the maximum number of reservations for this event",
      noReservation: "open reservation slots",
      noVoucher: "available Seat Credits",
      noTicketMsg:
        "You currently have no %{msg}. If you wish to book this event, please release one of your reservations.",
      seatChip: {
        one: "%{number} Seat",
        other: "%{number} Seats",
      },
      noSeats: "No seats meet your selection criteria.",
      backToSections: "BACK TO SECTIONS",
      members: "Members",
      membersAndGuests: "Members / Guests",
    },
    SelectTenant: {
      selectYourMembership: "Select Your Membership",
    },
    Settings: {
      settings: "Settings",
      includeAccessible: "Include Accessible",
      includeAccessibleDescription:
        "Include accessible seating in my seat selections by default",
      language: "Language",
    },
    SubscriptionDetail: {
      selectDifferentMember: "Select different member",
      planExpirationDate: "Plan expiration date: %{date}",
      planDetails: "Plan details",
      changePaymentInterval: "Change payment interval",
      cancelRenewal: "Cancel renewal",
      reinstateRenewal: "Reinstate renewal",
      upgradeAvailable: "Upgrade Available",
      cancelledOrReinstated:
        "You have %{action} %{planName} for %{memberName}.",
      cancel: "Cancel",
      reinstate: "Reinstate",
      cancelling: "cancelling",
      reinstating: "reinstating",
      cancelled: "cancelled",
      reinstated: "reinstated",
      reserveAnyTime: "Reserve any time",
      unlimited: "Unlimited",
      addPlanToMember: "Add Plan to This Member",
      addNewPlan: "Add new plan",
      planDetail: "%{planName} details",
      reservationWindow: "Reservation window: %{reservationWindow}",
      status: "Status: %{status}",
      maxVoucherPerGame: "Max vouchers per game: %{voucherPerGame}",
      cancelOrReinstateMembership: "%{action} Membership",
      choosePlanToUpgrade: "Choose a plan to upgrade",
      planAdded: "Plan added.",
      addingPlanToAccount: "Adding plan to your account, please wait...",
      noAdditionalPlans:
        "There are no additional plans available to this member.",
      chooseNewPlan: "Choose New Plan",
      addingPlan: "Adding Plan",
      planChanged: "Congratulations, your plan has been successfully changed.",
      currentPlan: "Current plan:",
      switchingPlans: "Switching Plans",
      switchingTo: "Switching to:",
      confirmUpgrade: "Confirm Upgrade",
    },
    UpdateBilling: {
      billingIntervalUpdated: "Billing interval updated",
      updateBillingInterval: "Update Billing Interval",
      changePaymentIntervalToFull: "Change Payment Interval to Pay-in-Full:",
      amountDueToday: "Amount due today",
      updatePaymentInterval: "Update payment interval",
      currentPaymentInterval: "Current payment interval:",
      monthly: "Monthly",
      pendingPaymentInterval: "Pending payment interval:",
      payInFull: "Pay In Full",
      amountDue: "Amount due:",
    },
  },
  errors: {
    form: {
      required: "This field is required",
      alphabetsOnly: "Only alphabets are allowed",
      email: "Email is not valid",
      phone: "Phone number is not valid",
      passwordMinimumLength: "Minimum password length is 6 characters",
      passwordsMustMatch: "Passwords must match",
      birthdate: "Birthdate is not valid",
    },
    screens: {
      DashboardScreen: {
        PHONE_VERIFY_TOKEN_INVALID:
          "Invalid phone verification code, please try again.",
      },
      Login: {
        UNAUTHORIZED: "Oops! Incorrect username or password. Let's try again.",
        TOO_MANY_LOGIN_ATTEMPTS:
          "Too many attempts! Please take a break or consider resetting your password.",
        DATA_VALIDATION_ERROR:
          "Hmmm, something's not right. Please check and complete all fields.",
        USER_ACCOUNT_SETUP_REQUIRED:
          "Looks like your account isn't set up yet. Please check your email for setup instructions.",
      },
      ForgotPassword: {
        DATA_VALIDATION_ERROR:
          "Your new password isn't quite strong enough. Make sure it meets our requirements.",
        USER_NOT_FOUND:
          "This email doesn't seem familiar to us. Double-check it and try again.",
        PASSWORD_RESET_TOKEN_ALREADY_USED:
          "This code has been used already. Please request a new one.",
        PASSWORD_RESET_TOKEN_NOT_YET_REQUESTED:
          "PASSWORD_RESET_TOKEN_NOT_YET_REQUESTED",
        PASSWORD_RESET_TOKEN_EXPIRED:
          "This code has expired. No worries, just request a new one.",
        PASSWORD_RESET_TOKEN_INVALID:
          "This code doesn't seem valid. Please check it or request a new one.",
        PASSWORD_TOO_SHORT:
          "Your password is a bit short. Could you try one with a few more characters?",
      },
      Register: {
        BILLING_ERROR:
          "Your credit card didn't go through. Could you check your details and try again?",
        INVALID_SUBSCRIPTION_TYPE_FOR_ACCOUNT:
          "It seems this subscription type isn't right for your account. Let's find a suitable option by trying to a different option. ",
        PLAN_PACKAGE_SOLD_OUT:
          "Unfortunately, this plan is now sold out due to high demand. Please explore other available options.",
        EMAIL_ADDRESS_ALREADY_IN_USE:
          "The email you've entered is already associated with an account. Do you need to reset your password?",
        USERNAME_ALREADY_IN_USE:
          "The username you've picked is already in use. Let's try a different one.",
      },
      AccountSetup: {
        BILLING_ERROR:
          "There's been an issue with your credit card. Could you check your details and give it another shot?",
        INVALID_SUBSCRIPTION_TYPE_FOR_ACCOUNT:
          "The subscription type selected isn't suitable for your account. Let's select a different that might be more compatible. ",
        PLAN_PACKAGE_SOLD_OUT:
          "Regrettably, this plan is sold out due to popular demand. Let's look at other great options.",
        EMAIL_ADDRESS_ALREADY_IN_USE:
          "The email address you've entered is already registered. Did you forget your password?",
        USERNAME_ALREADY_IN_USE:
          "It seems the username is already taken. Could you think of a different one?",
      },
      SeatSelection: {
        ITEM_NOT_FOUND:
          "There was an error with your request, please refresh the page and try again",
        DATA_VALIDATION_ERROR:
          "There was an error with your request, please try again",
        TICKET_ALREADY_RESERVED:
          "The chosen seats have been reserved already. Let's try finding other seats.",
        TICKET_QUANTITY_REQUIREMENTS_NOT_MET:
          "These seats require you to book the entire block of seats. Please update the quantity to reflect the entire block.",
        PER_GAME_REDEMPTION_MINIMUM_NOT_MET:
          "You have not met the required per-game redemption minimum for this event.",
      },
      Reserve: {
        EVENT_NOT_FOUND: "This event is not found, please try again",
        NOT_ENOUGH_RESERVATION_SLOTS:
          "Looks like you're out of reservation slots for this event. Please upgrade plan or wait till your slots open again. ",
        NOT_ENOUGH_VOUCHERS:
          "It seems you don't have enough vouchers for the party size requested. Can we adjust the party size?",
        TICKET_EXCEEDS_MAX_PER_EVENT:
          "Oops, you've reached the maximum number of reservations for this event.",
        NOT_ENOUGH_TICKETS_HELD:
          "You don't hold enough tickets to make this reservation. Let's review your ticket availability.",
        NO_MATURE_VOUCHERS:
          "It appears none of your vouchers are ready to use just yet. They'll mature soon!",
        ACCOUNT_PLAN_PACKAGE_NOT_EXISTS: "ACCOUNT_PLAN_PACKAGE_NOT_EXISTS",
        ACCOUNT_INACTIVE:
          "Your account is currently inactive, please refresh the page and try again.",
        ACCOUNT_MISSING_SUBSCRIPTION: "ACCOUNT_MISSING_SUBSCRIPTION",
        USER_ALREADY_HAS_TICKET_FOR_EVENT:
          "It looks like you already have a reservation for this event. Exciting, isn't it?",
        USER_NOT_IN_ACCOUNT: "USER_NOT_IN_ACCOUNT",
        TICKET_RESERVATION_WINDOW_TOO_EARLY:
          "This event is currently not open for reservation",
        TICKET_ALREADY_RESERVED:
          "Sorry, this ticket has already been reserved by someone.",
        SUBSCRIPTION_EXPIRED:
          "The selected event is past your subscription's expiry date. Let's find events within your subscription period.",
        GROUP_CODE_NO_ACCESS_TO_SECTION:
          "Your current plan doesn't grant access to this seating section. Maybe a plan upgrade?",
        GROUP_CODE_NO_ADJACENT_SEATS:
          "We've tried to move seats around but there isn't enough space in this section for your entire party to sit together. ",
        CURRENT_TIME_WITHIN_RESERVATION_CUTOFF_WINDOW:
          "This event is no longer available for redemption with this plan.",
        PER_GAME_REDEMPTION_MINIMUM_NOT_MET:
          "You have not met the required per-game redemption minimum for this event.",
        TICKET_CANNOT_CALCULATE_CHARGES:
          "Looks like the seats you were holding are no longer available. Please select other seats.",
      },
      EventDetail: {
        TICKET_RELEASE_WINDOW_EXPIRED:
          "This reservation can't be released as we're close to the game's start.",
        TICKET_CANNOT_BE_RELEASED:
          "Sorry, but we're too close to game time to release this reservation.",
        TICKET_NOT_FOUND:
          "We couldn't find this reservation. Could you try again a bit later?",
        TICKET_CANNOT_BE_RELEASED_BOOKING_FINAL:
          "This booking cannot be canceled because one or more of the seats have been transferred.",
      },
      Barcode: {
        TICKET_BARCODE_TOO_EARLY:
          "The barcode isn't ready yet. Please check back shortly.",
      },
      AddMembership: {
        ACCOUNT_ALREADY_EXISTS:
          "Looks like one or more members already have this subscription.",
        SUBSCRIPTION_ALREADY_EXISTS:
          "It appears one or more members already carry this subscription.",
        EMAIL_ADDRESS_ALREADY_IN_USE:
          "The email you've entered is already in use. Forgot the password, perhaps?",
        PLAN_PACKAGE_SOLD_OUT:
          "Regrettably, this plan is sold out due to high demand. Let's look at other options.",
      },
      GroupReservation: {
        EVENT_NOT_FOUND:
          "We're having trouble finding this event. Could you try again later?",
        GROUP_CODE_NOT_FOUND:
          "The group code you've entered doesn't match our records. Let's verify it again.",
        GROUP_CODE_NO_ACCESS_TO_SECTION:
          "Your current plan doesn't provide access to this seating section. Can we explore other options?",
        GROUP_CODE_NO_ADJACENT_SEATS:
          "Unfortunately, there's no space next to the original group. Let's find another seating option.",
      },
      ClaimVoucher: {
        TICKET_INVALID_TRANSFER_CODE:
          "The ticket transfer code seems incorrect. Can we verify it?",
        TICKET_CANNOT_BE_TRANSFERRED:
          "This ticket isn't transferable. Can we assist with something else?",
        TICKET_NOT_FOUND:
          "We can't seem to locate this ticket. Let's try again a bit later.",
      },
      Schedule: {
        EXTERNAL_USER_ACCOUNT_NOT_FOUND:
          "We couldn't find your MLB Ballpark account with the given email. Please double check that you are using the same e-mail address as your MLB Ballpark login.",
      },
      ClaimGift: {
        SUBSCRIPTION_GIFT_ALREADY_CLAIMED:
          "This gift has already been claimed.",
      },
    },
    GLOBAL: {
      USER_NOT_FOUND:
        "We couldn't find the user specified. Could we check the details again?",
      ACCOUNT_INACTIVE:
        "It seems your account information is outdated. Could we update it now?",
      ACCOUNT_NOT_FOUND:
        "We've found your user account, but it seems sign up isn't complete. Please choose a membership type to proceed.",
      REQUEST_TIMEOUT:
        "Our servers are a bit busy at the moment. Could you try again in a few minutes?",
      SESSION_EXPIRED: "Your session has expired. Please log in to continue.",
      PLAN_PACKAGE_SOLD_OUT:
        "This plan has sold out due to high demand. Let's look at other available plans.",
      SC_FORBIDDEN: "Something went wrong. Please try again.",
      BILLING_ERROR:
        "Your credit card didn't go through. Could you check your details and try again?",
      TOO_MANY_ACCOUNT_MEMBERS:
        "You have reached the maximum number of members for this account. Please remove a member to add another.",
      PHONE_ALREADY_IN_USE:
        "This phone number is already in use. Please try another one.",
      EMAIL_ADDRESS_ALREADY_IN_USE:
        "This email address is already in use. Please try another one.",
    },
    CATCHALL:
      "We're experiencing some difficulty processing your request. Could you try again a little later?",
  },
};
